import { render, staticRenderFns } from "./DeQuarter.vue?vue&type=template&id=5131a63e&scoped=true&"
import script from "./DeQuarter.vue?vue&type=script&lang=js&"
export * from "./DeQuarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5131a63e",
  null
  
)

export default component.exports